<div nz-row nzType="flex">
    <div nz-col nzSpan="6">
        <div class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <nz-form-item>
                <button nz-button nzType="primary" style="margin-right:0px;" [nzLoading]="loadprojectexcel"
                    (click)="importInExcel()"><i nz-icon nzType="file-excel" nzTheme="outline"></i></button>
            </nz-form-item>

            <nz-form-item>
                <button style="margin-right:0px;" nz-button [nzType]="isFilterApplied" (click)="showFilter()"><i nz-icon
                        nzType="filter"></i></button>
            </nz-form-item>

            <nz-form-item style="margin-right:0px;">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" autocomplete="off" nz-input placeholder="Search by User"
                        [(ngModel)]="searchText" (keydown.enter)="onEnterGetProjectWiseDetails()" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button name="button1" id="button1" nzType="primary" (click)="getProjectWiseDetails(true)"
                        nzSearch><i nz-icon nzType="search"></i></button>
                </ng-template>
            </nz-form-item>
        </form>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <div class="filter {{filterClass}}">
            <div class="filter-box">
                <form nz-form>
                    <div nz-row nzGutter="16">
                        <div nz-col nzSpan="12">
                            <nz-form-label nzNoColon>Project</nz-form-label>

                            <nz-input-group>
                                <nz-select name="projectName" style="width: 100%;" nzAllowClear nzShowSearch
                                    style="width: 100%" [(ngModel)]="projectID">
                                    <nz-option *ngFor="let project of projectList" [nzValue]="project.ID"
                                        [nzLabel]="project.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="10">
                            <nz-form-label>Actions</nz-form-label><br />

                            <nz-button-group nzSize="default">
                                <button style="margin-right: 10px;" nz-button nzType="primary"
                                    (click)="getProjectWiseDetails(true)" nzJustify="end">
                                    <i nz-icon nzType="filter"></i>Apply Filter
                                </button>

                                <button nz-button nzType="primary" (click)="clearFilter()">
                                    <i nz-icon nzType="filter"></i>Clear Filter
                                </button>
                            </nz-button-group>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <nz-table class="my-scroll no-wrap1" nzBordered #table nzShowSizeChanger [nzFrontPagination]="false"
            [nzData]="projectData" [nzLoading]="loadingRecords" [nzTotal]="totalRecords" [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize" (nzQueryParams)="sort($event)">

            <thead>
                <tr>
                    <th *ngFor="let column of columns" nzColumnKey="{{column[0]}}" [nzSortFn]="true">{{column[1]}}</th>
                    <th>User</th>
                    <th>Working Hours</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of table.data" style="cursor: pointer;">
                    <td *ngFor="let column of columns">{{data[column[0]]}}</td>
                    <td>{{data.USER_NAME}}</td>
                    <td>{{data.TOTAL_SECONDS | secondToHours}}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>